// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailSent_container__1iQzF","msg":"EmailSent_msg__2btHn","confirmBtn":"EmailSent_confirmBtn__26kb0"};